import React from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import Loader from '../../../Components/Loader'
import noneImage from '../../../assets/none-png-2.png'
import { Helmet } from 'react-helmet'
import Error from '../../../Components/Error'

const Container = styled.div`
    height: calc(100vh - 50px);
    width: 100%;
    position: relative;
    padding:70px;
    @media screen and (max-width:768px) {
        padding:0;
    }
`
const Backdrop = styled.div`
    position:absolute;
    top:0;
    left:0;
    width:100%;
    height:calc(100vh - 50px);
    background-image:url(${props => props.imgBg});
    background-position:center center;
    background-size:cover;
    filter:blur(3px);
    opacity:0.5;
    @media screen and (max-width:768px) {
        display:none;
    }
`

const Content = styled.div`
    display:flex;
    width: 100%;
    position:relative;
    z-index:1;
    height:100%;
    border-radius:5px;
    @media screen and (max-width:768px) {
        flex-direction:column;
        position: relative;
        width:100%;
    }
`

const Cover = styled.div`
    border-radius:5px;
    min-width:30%;
    margin-right:20px;
    background-image:url(${props => props.imgBg});
    background-position:center center;
    background-size:cover;
    height:100%;
    z-index:0;
    @media screen and (max-width:768px) {
        width:100%;
        margin:auto;
        z-index:-1;
        top:0;
        left:0;
        position:fixed;
        height:calc(100vh);
        z-index:-1;
        opacity:0.3
    }
`

const Data = styled.div`
    width:65%;
    height:100%;
    overflow: auto;
        -ms-overflow-style: none;
        &::-webkit-scrollbar {
            background:rgba(0,0,0,0.1)
        }
        &::-webkit-scrollbar-thumb {
            background: rgba(255,255,255,0.2);
    }
        &::-webkit-scrollbar-thumb:hover {
            background: rgba(255,255,255,0.5);
    }
    margin-left:10px;
    @media screen and (max-width:768px) {
        padding-top:5%;
        width:90%;
        margin-left:0;
        margin:0 auto;
        overflow:unset;
    }
`

const Title = styled.h3`
    font-size:32px;
    font-weight:600;
    padding-bottom:30px;
    @media screen and (max-width:768px) {
       font-size:23px;
       color:yellow;
    }
`
const ImageContainer = styled.div`
    display:flex;
    padding:20px;
    border-top:2px solid rgba(255,255,255,0.2);
    border-bottom:2px solid rgba(255,255,255,0.2);
    align-items:center;
    @media screen and (max-width:768px) {
       flex-direction:column;
       padding:10px;
    }
`
const Image = styled.img`
    display:block;
    border-radius:5px;
    width:30%;
    margin-right:15px;
    @media screen and (max-width:768px) {
       order:1;
       width:100%;
       margin:auto;
       padding:5px;
       border-radius:12px;
    }
`
const Overview = styled.div`
    font-size:18px;
    padding:5px 0 5px;
    line-height:1.5;
    width:70%;
    div{
        width:90%;
        padding-left:15px;
    }
    P:first-child{
        font-size:23px;
        color:yellow;
        padding:0;
    }
    p{
        color:#f5c518;
        font-weight:500;
        padding:10px;
    }
    @media screen and (max-width:768px) {
        order:2;
       width:100%;
       font-size:14px;
       div{
        width:100%;
    }
    P:first-child{
        font-size:18px;
        color:yellow;
    }
    p{
        padding:0 10px
    }
    }

`
const Foot = styled.div`
    display:none;
    @media screen and (max-width:768px) {
        display:block;
       height:20px;
    }
`
const SeasonPresenter
    = ({ loading, error, result, title }) => {
        return (
            loading ? <Loader /> : error ? <Error data={"No Season data...."} /> : result &&
                <Container>
                    <Helmet>
                        <title>
                            {result.name && title && title + ' ' + result.name} | Maflix
                    </title>
                    </Helmet>
                    <Backdrop imgBg={result.poster_path && result.poster_path ? `https://image.tmdb.org/t/p/w500${result.poster_path}` : null} />
                    <Content>
                        <Cover imgBg={result.poster_path && result.poster_path ? `https://image.tmdb.org/t/p/original${result.poster_path}` : noneImage} />
                        <Data>
                            <Title>
                                {result.name && title && title + ' - ' + result.name}
                            </Title>
                            {result.episodes && result.episodes.length > 0 && result.episodes.map((i) => (
                                <ImageContainer key={i.id}>
                                    <Overview >
                                        <p>{i.episode_number ? 'Episode ' + i.episode_number + ' : ' : null} {i.name && i.name}</p>
                                        <p>Air date</p>
                                        <div>{i.air_date && i.air_date}</div>
                                        <p>Overview</p>
                                        <div>{i.overview && i.overview}</div>
                                    </Overview>
                                    <Image src={i.still_path ? `https://image.tmdb.org/t/p/original${i.still_path}` : noneImage} />
                                </ImageContainer>))}

                            <Foot></Foot>
                        </Data>
                    </Content>
                </Container >)
    }

SeasonPresenter
    .propTypes = {
    loading: PropTypes.bool.isRequired,
    error: PropTypes.string,
    result: PropTypes.object
}

export default SeasonPresenter
